import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Toaster } from 'react-hot-toast';
import { theme } from './theme';
import Layout from './components/Layout';
import Hero from './components/Hero';
import HomeProductSection from './components/HomeProductSection';
import Footer from './components/Footer';
import AdminPanel from './components/AdminPanel';
import Login from './components/Login';
import Checkout from './components/Checkout';
import CategoryPage from './components/CategoryPage';
import ProductDetail from './components/ProductDetail';
import Contact from './components/Contact';
import PrivacyPolicy from './components/policies/PrivacyPolicy';
import CookiesPolicy from './components/policies/CookiesPolicy';
import RefundPolicy from './components/policies/RefundPolicy';
import { useAuthStore } from './firebase/auth';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((state) => state.user);
  const loading = useAuthStore((state) => state.loading);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#00ff00]"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Toaster position="top-right" />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/panelam"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <Layout>
                <Hero />
                <HomeProductSection />
                <Footer />
              </Layout>
            }
          />
          <Route
            path="/categoria/:type"
            element={
              <Layout>
                <CategoryPage />
                <Footer />
              </Layout>
            }
          />
          <Route
            path="/producto/:id"
            element={
              <Layout>
                <ProductDetail />
                <Footer />
              </Layout>
            }
          />
          <Route
            path="/contacto"
            element={
              <Layout>
                <Contact />
                <Footer />
              </Layout>
            }
          />
          <Route
            path="/checkout"
            element={
              <Layout>
                <Checkout />
                <Footer />
              </Layout>
            }
          />
          <Route
            path="/politicas/privacidad"
            element={
              <Layout>
                <PrivacyPolicy />
                <Footer />
              </Layout>
            }
          />
          <Route
            path="/politicas/cookies"
            element={
              <Layout>
                <CookiesPolicy />
                <Footer />
              </Layout>
            }
          />
          <Route
            path="/politicas/devoluciones"
            element={
              <Layout>
                <RefundPolicy />
                <Footer />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
